import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useBanner } from "./useBanner";
import { MuiMarkdown_V2 } from "../../../../Shared/components/MuiMarkdown/MuiMarkdown_V2";
export const Banner = ({ sequenceNumber, margin }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
    const { bannerImage, showTextBlock, bubbleText, textStyle, bubbleStyle, desktopImageMaxHeight, mobileImageMaxHeight, } = useBanner(sequenceNumber);
    if (!bannerImage)
        return _jsx(_Fragment, {});
    if (isMobile) {
        return (_jsxs(Box, Object.assign({ boxShadow: 3, style: {
                display: "flex",
                flexDirection: "column",
                position: "relative",
                overflow: "hidden",
                marginLeft: margin,
                marginRight: margin,
            } }, { children: [_jsxs(Box, Object.assign({ style: {
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        overflow: "hidden",
                    } }, { children: [_jsx("img", { src: bannerImage, style: { maxHeight: `${mobileImageMaxHeight}px`, objectFit: "cover" } }), showTextBlock && _jsx(Box, { style: bubbleStyle })] })), showTextBlock && (_jsx(Box, Object.assign({ style: textStyle }, { children: _jsx(MuiMarkdown_V2, { children: bubbleText }) })))] })));
    }
    else {
        return (_jsxs(Box, Object.assign({ boxShadow: 3, style: {
                display: "flex",
                flexDirection: "column",
                position: "relative",
                overflow: "hidden",
                marginLeft: margin,
                marginRight: margin,
            } }, { children: [_jsx("img", { src: bannerImage, style: { maxHeight: `${desktopImageMaxHeight}px`, objectFit: "cover" } }), showTextBlock && (_jsx(Box, Object.assign({ style: bubbleStyle }, { children: _jsx(Box, Object.assign({ style: textStyle }, { children: _jsx(MuiMarkdown_V2, { children: bubbleText }) })) })))] })));
    }
};
